import throttle from 'lodash/throttle.js'
import { onMounted, onUnmounted, ref } from 'vue'

export const useHiddenHeader = (scrollHandler?: () => void) => {
  const MIN_SCROLL = 300
  const smallHeader = ref(false)

  const toggleHideHeader = (val: boolean) => (smallHeader.value = val)
  const onResultsScroll = throttle(function () {
    smallHeader.value = window.scrollY >= MIN_SCROLL
  })

  onMounted(() =>
    window.addEventListener('scroll', scrollHandler ? scrollHandler : onResultsScroll)
  )
  onUnmounted(() =>
    window.removeEventListener('scroll', scrollHandler ? scrollHandler : onResultsScroll)
  )

  return {
    smallHeader,
    toggleHideHeader,
    minScroll: MIN_SCROLL
  }
}
